/** BRC brand logo (official wordmark). */
export function BrcLogo({ className = '' }: { className?: string }) {
  return (
    <img
      src="/brc-logo.png"
      alt="BRC"
      className={`h-10 w-auto ${className}`}
    />
  );
}
